module.exports = __webpack_public_path__ + "static/2.0d9c6df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/2.jpg
// module id = 712
// module chunks = 168707334958949